module.exports = __webpack_public_path__ + "static/BDST-Regular-aaa21053fc67f02374adafe16641e9ef.woff";